import * as z from "zod/v4";

export const getCartValidationFunctionStatus = {
  name: "getCartValidationFunctionStatus" as const,
  input: z.object({}),
  output: z.object({ isInstalled: z.boolean(), isEnabled: z.boolean() }),
};
